import React from 'react';

class Download extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <p>Download the app, sign up and open this invite in the app to join.</p>
        <a href='https://play.google.com/store/apps/details?id=com.wimit.app'>
          <img className='download-android' alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
        </a>
        <a href="https://apps.apple.com/gb/app/wimit/id1029890307?itsct=apps_box_badge&amp;itscg=30200">
          <img className='download-ios' src='https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us' alt='Download on the App Store' />
        </a>
      </React.Fragment>
    )
  }
}

export default Download;
